import InnerComponent from '@Components/Production/ManufacturingOrders/ViewManufacturingOrder';
import orgContainer from '@Components/AppContainer';

const ViewManufacturingOrder = () => ((orgContainer(InnerComponent)));
export default ViewManufacturingOrder;
